export const T = {
  en_GB: {
    securitySettings: "Security Settings",
    description: "Manage your password, two-factor authentication, and account security",
  },
  nb_NO: {
    securitySettings: "Sikkerhetsinnstillinger",
    description: "Administrer passord, tofaktorautentisering og kontosikkerhet",
  },
} as const;
